import { useTranslation } from 'react-i18next';

export default function Email(props) {
  let link;
    
  const { t, i18n } = useTranslation();

  if ( props.content ) {
    link = <a href={'mailto:' + props.content.value} target="_blank">{props.content.value}</a>;
  }

  return(
    <div>
      {link}
    </div>
  );
}
